const CompleteStepBusinessType = {
  procedureFile: {
    dataKey: "procedureFolder",
    settingKey: "getProcedureFileStepComletedItem",
  },
  supportingFile: {
    dataKey: "supportingFolder",
    settingKey: "getCreateSupportingFileStepCompletedItem",
  },
  shareTask: {
    dataKey: "shareTask",
    settingKey: "getShareTask",
  },
  procedureOwner: {
    dataKey: "procedureOwner",
    settingKey: "getProcedureOwnerStepItem",
  },
  primaryProcedureOwner: {
    dataKey: "primaryProcedureOwner",
    settingKey: "getPrimaryProcedureOwnerStepItem",
  },
  jBStatus: {
    dataKey: "applyJBStatus",
    settingKey: "getApplyJBStatusStepItem",
  },
  pmpExcluded: {
    dataKey: "applyPmpExcluded",
    settingKey: "getApplyPmpExcludedStepItem",
  },
  tLReview: { dataKey: "tlReview", settingKey: "getTLReviewStepItem" },
  signOff: { dataKey: "signOff", settingKey: "getSignOffStepItem" },
  taskInfo: { dataKey: "taskInfomation", settingKey: "getTaskInformation" },
};

export default CompleteStepBusinessType;
